const showPermissionNav = (nav) => {
  if (nav === 1) { return '栏目' }
  else if (nav === 3) { return '菜单' }
  return '权限'
}

const showPermissionStaus = (nav) => {
  if (nav === 1) { return '启用' }
  return '停用'
}

const showSex = (sex) => {
  if (sex === 1) { return '男' }
  return '女'
}

const showDelflag = (flag) => {
  if (flag === 1) { return '启用' }
  return '禁用'
}

const showUserStatus = (status) => {
  if (status === 1) { return '正常' }
  return '屏蔽'
}

const showCommonStatus = (status) => {
  if (status === 1) { return '正常' }
  return '屏蔽'
}

const showUserLoginStatus = (status) => {
  if (status === 1) { return '成功' }
  return '失败'
}

const formatDateUnix = (date, fmt) => {
  if (date === undefined || date === '') { return '' }
  let date1 = new Date(date);
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date1.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date1.getMonth() + 1,
    'd+': date1.getDate(),
    'h+': date1.getHours(),
    'm+': date1.getMinutes(),
    's+': date1.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
}

/**
 * 格式化当前日期
 * @param {boolean} withTime - 是否包含时分秒，默认false
 * @returns {string} 格式化后的日期字符串
 */
const formatCurrentDate = (withTime = false) => {
  const now = new Date();
  
  // 获取年、月、日（注意：月份从0开始，所以要+1）
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // 补零，比如9月变成09
  const day = String(now.getDate()).padStart(2, '0');

  if (!withTime) {
    return `${year}-${month}-${day}`;
  }

  // 获取时、分、秒（同样补零）
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const padLeftZero = (str) => {
  return ('00' + str).substr(str.length);
}

const showBalanceway = (way) => {
  let t;
  if (way === 1) { t = '日结' }
  else if (way === 2) { t = '周结' }
  else if (way === 3) { t = '半个月结' }
  else if (way === 4) { t = '月结' }
  else if (way === 5) { t = '季结' }
  else if (way === 6) { t = '半年结' }
  else if (way === 7) { t = '年结' }
  return t
}

const showYesNo = (flag) => {
  let t;
  if (flag === 1) { t = '有' }
  else if (flag === 2) { t = '无' }
  return t
}

const showPayWay = (flag) => {
  let t;
  if (flag === 1) { t = '对公付款' }
  else if (flag === 2) { t = '对私付款' }
  // else { t = '其他'}
  return t
}

const showPaidWay = (flag) => {
  let t;
  if (flag === 1) { t = '对公收款' }
  else if (flag === 2) { t = '对私收款' }
  // else { t = '其他'}
  return t
}

const showGoodsStatus = (flag) => {
  let t;
  if (flag === 1) { t = '上架' }
  else if (flag === 2) { t = '下架' }
  //else { t = '其他'}
  return t
}

const showOrderStatus = (flag) => {
  let t;//待发货、备货中、发货失败、已发货、发货完结、已取消
  if (flag === 1) { t = '待发货' }
  else if (flag === 2) { t = '备货中' }
  else if (flag === 3) { t = '发货失败' }
  else if (flag === 4) { t = '已发货' }
  else if (flag === 5) { t = '发货完结' }
  else if (flag === 6) { t = '已取消' }
  else { t = '其他'}

  // if (flag === 1) { t = '备货中' }
  // else if (flag === 2) { t = '发货失败' }
  // else if (flag === 3) { t = '发货完成' }
  // else if (flag === 4) { t = '已取消' }
  // else { t = '其他'}
  return t
}
const showOrderType = (flag) => {
  let t;
  if (flag === 1) { t = '常规订单' }
  else if (flag === 2) { t = '拆分订单' }
  else if (flag === 3) { t = '礼包订单' }
  // else { t = '其他'}
  return t
}

const showOrderAbnormalStatus = (flag) => {
  let t;
  if (flag === 1) { t = '未处理' }
  else if (flag === 2) { t = '跟进中' }
  // else { t = '其他'}
  return t
}

const showOrderMaoliv = (flag) => {
  let t;
  if (flag === 1) { t = '正常' }
  else if (flag === 2) { t = '异常' }
  // else { t = '其他'}
  return t
}

const showInvoiceType = (flag) => {
  let t;
  if (flag === 1) { t = '增值税专用发票' }
  else if (flag === 2) { t = '增值税普通发票' }
  else if (flag === 3) { t = '不开票' }
  return t
}

const showSaleType = (flag) => {
  let t;
  if (flag === 1) { t = '退货' }
  else if (flag === 2) { t = '换货' }
  else if (flag === 3) { t = '安比例赔付' }
  else if (flag === 4) { t = '仅退款未发货' }
  else if (flag === 5) { t = '其他' }
  return t
}

const showSaleStatus = (flag) => {
  let t;
  if (flag === 1) { t = '未完成' }
  else if (flag === 2) { t = '已完成' }
  else if (flag === 3) { t = '已作废' }
  return t
}
const showSaleSupplieramount = (flag) => {
  let t;
  if (flag === 1) { t = '已打款抵扣余款' }
  else if (flag === 2) { t = '未打款' }
  else if (flag === 3) { t = '月结已付抵扣余款' }
  else if (flag === 4) { t = '已退款' }
  else if (flag === 5) { t = '未退款' }
  else if (flag === 6) { t = '未修改' }
  return t
}

//客户对账状态12
//供应商对账状态1已对账2未对账
const showVerifyStatus = (flag) => {
  let t;
  if (flag === 1) { t = '已对账' }
  else if (flag === 2) { t = '未对账' }
  return t
}
const showVerifyCustomerStatus = (flag) => {
  let t;
  if (flag === 1) { t = '已收款' }
  else if (flag === 2) { t = '未收款' }
  return t
}
const showVerifySupplierStatus = (flag) => {
  let t;
  if (flag === 1) { t = '已付款' }
  else if (flag === 2) { t = '未付款' }
  return t
}
//客户结算状态123
// 供应商结算状态1已结算2未结算3已抵扣
const showVerifySetStatus = (flag) => {
  let t;
  if (flag === 1) { t = '已结算' }
  else if (flag === 2) { t = '未结算' }
  else if (flag === 3) { t = '已抵扣' }
  return t
}

//客户类型1积分客户2电商客户
const showCustomerType = (flag) => {
  let t
  if (flag === 1) { t = '积分客户' }
  else if (flag === 2) { t = '电商客户' }
  else if (flag === 3) { t = '其他客户' }
  else if (flag === 4) { t = '企业福利' }
  else if (flag === 5) { t = '产品分销' }
  return t
}

//供应商有无账期 日、周、月、半月、年结
const supplierAccount = (flag) => {
  let t
  if (flag === 1) { t = '日' }
  else if (flag === 2) { t = '周' }
  else if (flag === 3) { t = '月' }
  else if (flag === 4) { t = '半月' }
  else if (flag === 5) { t = '年结' }
  return t
}

const getPriceRange = (ptype) => {
  let data = []
	for(let i=0;i<2550;i=i+50){
		let p = i-50
		if (p<0){continue}
		data.push({p,i})
	}
  let t = '2550+'
  // console.log(ptype,data[ptype])
  // if (data[ptype]!=='undefined') {
  if ( typeof(data[ptype])!=='undefined') {
      t = data[ptype].p+'-'+data[ptype].i;
  }
  return t

	// console.log(data)

	// let price = 150
	// for(let i=0;i<data.length;i++) {
	// 	console.log(data[i].p,'----',data[i].i)
	// 	if (price>=data[i].p && price<data[i].i) {
	// 	console.log('price range :'+ (i+1))
	// 	}
	
}
/**
 * 计算两个日期的自然日天数差（忽略时分秒）
 * @param {Date|string} date1 日期1（Date对象或合法日期字符串）
 * @param {Date|string} date2 日期2（Date对象或合法日期字符串）
 * @returns {number|null} 天数差（date2 - date1，无效日期返回null）
 */
const calculateDayDifference = (date1, date2) => {
  // 1. 转换为Date对象
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  
  // 2. 校验日期有效性
  if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
    // console.error('传入的日期格式无效！');
    return null;
  }
  
  // 3. 重置时分秒毫秒，只保留日期部分
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);
  
  // 4. 计算并返回带正负的天数差（核心修改处）
  const timeDiff = d2.getTime() - d1.getTime(); // 移除Math.abs，保留正负
  return timeDiff / 86400000; // 因已重置时分秒，差值必为86400000的整数倍，无需Math.floor
}

// const getPriceRange = (ptype) => {

//   let t = '';
//   if (ptype == 1) {
//     t = '0-50';
//   } else if (ptype == 2) {
//     t = '50-100';
//   } else if (ptype == 3) {
//     t = '100-150';
//   } else if (ptype == 4) {
//     t = '150-200';
//   } else if (ptype == 5) {
//     t = '200-250';
//   } else if (ptype == 6) {
//     t = '250-300';
//   } else if (ptype == 7) {
//     t = '300-450';
//   } else if (ptype == 8) {
//     t = '450-500';
//   } else if (ptype == 9) {
//     t = '500-550';
//   } else if (ptype == 10) {
//     t = '550-600';
//   } else if (ptype == 11) {
//     t = '600-650';
//   } else if (ptype == 12) {
//     t = '650-700';
//   } else if (ptype == 13) {
//     t = '700-750';
//   } else if (ptype == 14) {
//     t = '750-800';
//   } else if (ptype == 15) {
//     t = '800-850';
//   } else if (ptype == 16) {
//     t = '850-900';
//   } else if (ptype == 17) {
//     t = '900-950';
//   } else if (ptype == 18) {
//     t = '950-1000';
//   } else if (ptype == 19) {
//     t = '1000-1050';
//   } else if (ptype == 20) {
//     t = '1050-1100';
//   } else if (ptype == 21) {
//     t = '1100-1150';
//   } else if (ptype == 22) {
//     t = '1150-1200';
//   } else if (ptype == 23) {
//     t = '1200-1250';
//   } else if (ptype == 24) {
//     t = '1250-1300';
//   } else if (ptype == 25) {
//     t = '1300-1350';
//   } else if (ptype == 26) {
//     t = '1350-1400';
//   } else if (ptype == 27) {
//     t = '1400-1450';
//   } else if (ptype == 28) {
//     t = '1450-1500';
//   } else if (ptype == 29) {
//     t = '1500-1550';
//   } else if (ptype == 30) {
//     t = '1550-1600';
//   } else if (ptype == 31) {
//     t = '1600-1650';
//   } else if (ptype == 32) {
//     t = '1650-1700';
//   } else if (ptype == 33) {
//     t = '1700-1750';
//   } else if (ptype == 34) {
//     t = '1750-1800';
//   } else if (ptype == 35) {
//     t = '1800-1850';
//   } else if (ptype == 36) {
//     t = '1850-1900';
//   } else if (ptype == 37) {
//     t = '1900-1950';
//   } else if (ptype == 38) {
//     t = '1950-2000';
//   } else if (ptype == 39) {
//     t = '2000-2050';
//   } else if (ptype == 40) {
//     t = '2050-2100';
//   } else if (ptype == 41) {
//     t = '2100-2150';
//   } else if (ptype == 42) {
//     t = '2150-2200';
//   } else if (ptype == 43) {
//     t = '2200-2250';
//   } else if (ptype == 44) {
//     t = '2250-2300';
//   } else if (ptype == 45) {
//     t = '2300-2350';
//   } else if (ptype == 46) {
//     t = '2350-2400';
//   } else if (ptype == 47) {
//     t = '2400-2450';
//   } else if (ptype == 48) {
//     t = '2450-2500';
//   } else if (ptype == 49) {
//     t = '2500-2550';
//   } else {
//     t = '2550+';
//   }
//   return t;
// }
/**
 * textarea 换行文本通用解析
 * @param {string} text 原始文本
 * @param {Object} options 配置
 * @param {boolean} options.unique 是否数组去重，默认 false
 * @returns {string[]} 清洗后的干净数组
 */
const parseLineText = (text, options = {}) =>{
  const { unique = false } = options;
  // 空值兜底
  if (!text || typeof text !== 'string') return [];

  let list = text
      // 兼容 windows \r\n 、mac/linux \n 所有换行
      .split(/\r?\n/)
      // 每一行去除首尾空格
      .map(item => item.trim())
      // 过滤空行、空白字符串
      .filter(item => item.length > 0);

  // 开启去重
  if (unique) {
      list = [...new Set(list)];
  }
  return list;
}

/**
* 文本格式化整理：清理空行、多余换行，一行一条内容
* @param {string} text 原始文本
* @param {Object} options 同 parseLineText
* @returns {string} 规整后的换行字符串
*/
const formatLineText = (text, options = {}) =>{
  const arr = parseLineText(text, options);
  return arr.join('\n');
}

// // 1、基础用法：只清理空行空格
// parseLineText(str)

// // 2、清理+自动去重
// parseLineText(str, { unique: true })

// // 3、整理界面文本，去除多余空行
// formatLineText(str)
// formatLineText(str, { unique: true })

export default {
  parseLineText,
  formatLineText,
  showSex,
  showDelflag,
  showUserStatus,
  showPermissionNav,
  showPermissionStaus,
  showUserLoginStatus,
  formatDateUnix,
  showCommonStatus,
  showBalanceway,
  showYesNo,
  showPayWay,//supplier
  supplierAccount,
  showPaidWay,//customer
  showGoodsStatus,
  showOrderStatus,
  showOrderType,
  showOrderAbnormalStatus,
  showOrderMaoliv,
  showInvoiceType,
  showSaleType,
  showSaleStatus,
  showSaleSupplieramount,
  showVerifyStatus,
  showVerifyCustomerStatus,
  showVerifySupplierStatus,
  showVerifySetStatus,
  showCustomerType,
  getPriceRange,
  calculateDayDifference,
  formatCurrentDate
}